import request from '../../../api/request';

import {
  StudentFileFormDataResponse,
  StudentFilePostulantRequest,
} from './types';

const STUDENT_FILE = {
  GET_POSTULANTS: 'maintainers-portal/student-management/student-file',
  GET_FORM_DATA: 'maintainers-portal/student-management/student-file/form',
};

export const getFormData = () => {
  return request<StudentFileFormDataResponse>(STUDENT_FILE.GET_FORM_DATA);
};

export const getPostulants = (params: StudentFilePostulantRequest) => {
  return request<any>(STUDENT_FILE.GET_POSTULANTS, {
    params,
  });
};
